//Libs
import React from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import { withStyles } from '@material-ui/core';
//Útils
import formatarUrlImagem from '../utils/formatarUrlImagem';

/**
 * Estilo CSS do componente
 */
const styles = () => ({
    imagem: {
        minWidth: '1px'
    }
});

/**
 * Componente utilizado para renderizar uma imagem, com os estilos CSS e montando a URL para a API
 * @param {Object} props Propriedades passadas para o componente
 * @param {Object} props.classes Classes CSS do componente
 * @param {String} props.classes.imagem Classe CSS do componente de imagem
 * @param {String} props.src Identificação da imagem, para montar a URL
 * @param {String} props.alt Descricação alternativa da imagem
 * @param {String|Number} props.maxWidth Tamanho máximo do componente em pixels
 */
function Imagem({ classes, src, alt, maxWidth }) {
    return (
        <img className={classes.imagem} src={formatarUrlImagem(src)} alt={alt} style={{ maxWidth: maxWidth ?? '100%' }} />
    );
}

Imagem.propTypes = {
    /** Identificação da imagem, para montar a URL */
    src: PropTypes.string.isRequired,
    /** Descrição alternativa da imagem */
    alt: PropTypes.string.isRequired,
    /** Tamanho máximo do componente em pixels */
    maxWidth: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    /** Classes CSS do componente */
    classes: PropTypes.shape({
        imagem: PropTypes.string
    })
};

export default withStyles(styles)(Imagem);